
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/library",
      function () {
        return require("private-next-pages/library/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/library"])
      });
    }
  